import * as authActions from '../screens/Auth/redux/action';

export default {
  ...authActions,
};
